module.exports = __webpack_public_path__ + "static/media/dinosofia.62781dfb.jpg";